<template>
  <div id="jumbo" class="container-fluid" data-v-7b0626b6></div>

  <div id="art" class="container">
    <h1>art.</h1>
    <div class="row justify-content-center" style="margin-top: 30px">
      <div class="col-12 col-md-4">
        <router-link to="/powerful">
          <img
            src="/img/Energy_quadrat.ecab77f5.jpg"
            class="img-fluid"
            alt="..."
            style="width: 100%; cursor: pointer"
          />
          <p style="margin-top: 10px" class="grouptext" data-v-7b0626b6>Powerful Series</p>
        </router-link>
      </div>
      <div class="col-12 col-md-4">
        <router-link to="/colorful">
          <img
            src="/img/Beauty_of_Nature_quadrat.7aae9fc9.jpg"
            class="img-fluid"
            alt="..."
            style="width: 100%; cursor: pointer"
          />
          <p style="margin-top: 10px" class="grouptext" data-v-7b0626b6>Colorful Series</p>
        </router-link>
      </div>
      <div class="col-12 col-md-4">
        <router-link to="/calm">
          <img
            src="/img/Blue_Ocean_quadrat.d59fa102.jpg"
            class="img-fluid"
            alt="..."
            style="width: 100%; cursor: pointer"
          />
          <p style="margin-top: 10px" class="grouptext" data-v-7b0626b6>Calm Series</p>
        </router-link>
      </div>
      <div class="col-12 col-md-4">
        <router-link to="/gold">
          <img
            src="/img/Pure_gold_q.jpg"
            class="img-fluid"
            alt="..."
            style="width: 100%; cursor: pointer"
          />
          <p style="margin-top: 10px" class="grouptext" data-v-7b0626b6>Gold Series</p>
        </router-link>
      </div>
    </div>
  </div>

  <div id="about" class="container-fluid" style="background-color: #cacaca">
    <div class="container" style="padding-top: 20px; padding-bottom: 50px">
      <h1>about.</h1>
      <div class="row justify-content-center" style="margin-top: 30px">
        <div class="col-12 col-md-4">
          <img src="/img/Moni_normal.62634c1c.d61c8898.jpg" class="img-fluid" alt="..." />
        </div>

        <!-- German copy, shown for de / de-AT / de-BE / de-CH / de-DE / de-IT / de-LI / de-LU -->
        <div
          v-if="isGerman"
          class="col-12 col-md-4"
          style="text-align: justify; text-justify: inter-word"
        >
          <p>Monika-Theresia Wesseli ist eine Künstlerin aus der Nähe von München.</p>
          <p>
            Obwohl sie eigentlich Apothekerin ist, war sie seit jeher begeistert von Kunst. Weil
            ihre Eltern große Kunstliebhaber sind, besuchte sie seit ihrer Kindheit viele
            Ausstellungen - und damit ihr nicht langweilig wurde, war der Skizzenblock immer dabei.
            Von allen Orten in Europa und den USA, die sie besucht hat, sind ihr die Fondation
            Maeght und die Art Basel besonders ans Herz gewachsen. Inspiriert von Künstlern wie Cy
            Twombly, Emil Schumacher oder Gerhard Richter malt sie hauptsächlich mit Acryl auf
            Leinwand.
          </p>
        </div>

        <!-- English copy, shown for every other browser language -->
        <div v-else class="col-12 col-md-4" style="text-align: justify; text-justify: inter-word">
          <p>Monika-Theresia Wesseli is a German artist based near Munich.</p>
          <p>
            As a pharmacist by profession she has been into art all life long. Since her parents are
            huge artlovers, she has visited many exhibitions throughout her childhood. Her parents
            used to carry a sketchbook for her into every museum or exhibtion so that she could
            paint her impressions and wasn’t too bored. She visited many places in Europe and the
            US, but Fondation Maeght and Art Basel have always been her favourite ones. Inspired by
            artists like Cy Twombly, Emil Schumacher or Gerhard Richter she loves to paint primarily
            with acryl on canvas.
          </p>
        </div>
      </div>
    </div>
  </div>

  <div>
    <div id="contact" class="container">
      <h1>contact.</h1>
      <p>
        Are you interested in my work? Drop me an email to
        <a href="mailto:monika-theresia@kalliscriptum.com">monika-theresia@kalliscriptum.com</a>
      </p>
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from "vue";

// Browser locales treated as "German-speaking" for the about section
const GERMAN_LOCALES = ["de", "de-AT", "de-BE", "de-CH", "de-DE", "de-IT", "de-LI", "de-LU"];

export default {
  name: "Home",
  setup() {
    const isGerman = ref(false);

    onMounted(() => {
      const lang = navigator.language || navigator.userLanguage;
      console.log("The language is: " + lang);
      isGerman.value = GERMAN_LOCALES.includes(lang);
    });

    return { isGerman };
  },
};
</script>
